module.exports = __webpack_public_path__ + "media/images/flags/64/Cuba-e64ef9e5e98b1882b3ad6cde8d408294.png";